import { render, staticRenderFns } from "./ManageTeamsTable.vue?vue&type=template&id=0a64c41a&scoped=true&"
import script from "./ManageTeamsTable.vue?vue&type=script&lang=js&"
export * from "./ManageTeamsTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageTeamsTable.vue?vue&type=style&index=0&id=0a64c41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64c41a",
  null
  
)

export default component.exports